<template>
  <div>
    <div style="padding-top: 20px; padding-left: 20%">
      <!-- <img src="../../../assets/images/bdlogo.png" style="height: 100px; width: 400px" /> -->
<!--      <img src="../../../assets/images/bdlogo.png" style="height: 115px; width: 365px" />-->
    </div>
    <div class="login_form_box">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>杭州市上城人力招聘网上报名系统</span>
        </div>
        <el-form ref="编辑" :model="loginForm" :rules="rules" size="medium">
          <el-form-item prop="idCode">
            <el-input v-model="loginForm.idCode" placeholder="请输入您的身份证号码" clearable prefix-icon="el-icon-user"
              :style="{ width: '100%' }"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" placeholder="请输入您的密码" clearable prefix-icon="el-icon-lock"
              show-password :style="{ width: '100%' }"></el-input>
          </el-form-item>
<!--          <el-form-item label-width="0" prop="isAgree">
            <el-checkbox v-model="loginForm.isAgree">我已阅读并同意 《
              <el-button type="text" @click="dialogVisible = true"><span style="color: #3b7f29">杭州市上城区事业单位网上报名协议</span>
              </el-button>
              》
            </el-checkbox>
          </el-form-item>-->
          <el-form-item size="large">
            <el-button :style="{ width: '100%' }" type="primary" :disabled="!loginForm.isAgree" @click="handleClick">登录
            </el-button>
          </el-form-item>

          <div class="login-register">
            <span class="lossPwd" @click="lossPassword">忘记密码？</span>
            <span class="goRegester" @click="toRegister">
              <span>没有账号？</span>
              前往注册
            </span>
          </div>
          <br />
          <p class="login-flag">@杭州市上城人力招聘网上报名系统</p>
        </el-form>
      </el-card>
    </div>
    <div class="notice">
      <el-carousel indicator-position="inside" style="height: 100%">
        <el-carousel-item v-for="(item, index) in wanglaoban" :key="index">
          <div class="contentBox">
            <!--            <p>{{ item.createTime }}</p>-->
            <h3 @click="checkContent(item)">{{ item.articleTitle }}</h3>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <el-dialog title="杭州市上城区事业单位网上报名协议" :visible.sync="dialogVisible" :fullscreen="true" :center="true">
      <div class="content">
        一、杭州市上城区事业单位人事考试服务平台网上报名系统（以下简称服务平台）的所有权归杭州市上城区事业单位所有，报考人员使用服务平台进行网上报名，视为报考人员同意服务平台所有服务条款<br />
        二、报考人员责任<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1．保证所提供相关证明材料和提交的报名信息真实、客观。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2．保证不利用本平台从事违反法律、法规和政策规章的活动。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3．保证不进行针对本平台的任何恶意行为，对于破坏本平台的恶意行为，将依法追究其相应法律责任。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.
        承诺已认真阅读本服务协议，并点击“我接受”选项之后，表示已与我公司方(杭州上城区人力资源开发服务有限公司，以下简称杭州市上城区事业单位)自愿达成本协议，并完全接受协议各条款的约束。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.
        报考人员承诺将仔细阅读本平台上指导报名和考试的有关通知、政策、制度、流程、问题解答及公告等内容作为本服务使用协议的附属条款加以遵守，并严格按照其要求进行操作。<br />
        三、报考人员隐私保护<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1．杭州市上城区事业单位承诺尊重和保护报考人员个人隐私，不对社会公众公开其个人信息资料。但此承诺在下列情况下自动失效：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）报考人员（包括其授权人）要求杭州市上城区事业单位公开这些信息，并采用书面形式提出上述要求。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）在符合国家政策和法律的情况下，拥有合法调查权的国家机关索取考生个人信息。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）按照有关规定公布违纪违规考生的相关信息。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）非杭州市上城区事业单位过失，因报考人员自身操作原因或不可抗力的作用所导致的个人信息泄漏。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2．杭州市上城区事业单位系统维护、组织考试、管理考籍等内部管理工作需要，在相应工作范围内使用并公开考生个人信息料不受本协义的约束。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3．在考试制度和考试业务允许范围内，报考人员有查阅和修改其个人信息的权利。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4．如果报考人员提供的资料不真实、不准确，杭州市上城区事业单位有权中止报考人员使用本系统服务的权利。<br />
        四、关于考试费用支付<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1．用户完全接受报考通知上所列出的相关考试费用。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2．报考人员同意并接受以下支付方式及责任分担：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）根据所在省（区、市）考试机构确定的支付方式进行考试费用支付，支付方式分为现场支付和网上支付。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）现场支付指报考人员确认资格审查通过后，到考试机构指定单位支付费用，如报考人员需要，考试机构应出具收据或发票。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）采用网上支付的，通过服务平台将报考人员缴费操作联接到指定银行的支付网关，从而实现网上支付。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（4）电子银行网上消费支付结算按考生开户银行的网上银行服务协议的有关条款进行。我方只提供相应的链接服务，如付费交易过程中出现错误由报考生与开户银行共同解决，杭州市上城区事业单位不承担责任。<br />
        五、关于服务条款的修改<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、我方有权随时修改系统的服务条款和服务内容。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、系统服务条款及服务内容一旦发生变化，杭州市上城区事业单位将会在网页页面提示修改内容。如果考生不接受修改内容，则即时取消考生本网站使用服务资格。考生要继续使用相关服务需要两方面的确认：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）首先确认系统服务条款及其变动。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）同意接受所有的服务条款限制。<br />
        六、关于考生密码和安全性<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1．禁止使用他人身份登录系统享受系统提供的服务。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2．考生有妥善保管其登录密码的义务，因考生对自己的密码安全保管不善所造成的损失，由其本人负全部责任。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3．考生如发现任何程序问题或安全漏洞情况，请立即通知我方。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4．考生用于银行支付的密码系由银行提供，应仅属考生本人知晓，杭州市上城区事业单位无权获知，亦不对其银行密码安全承担任何责任。<br />
        七、关于结束服务<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1．我方有权随时中断服务，我方行使中断服务的权利不需对考生或第三方负责。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2．考生若反对任何服务条款的建议或对后来的条款修改有异议，或对我方网络系统服务不满，仅享有以下的权利：<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（1）不再使用我方网络系统提供的服务。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）通知我方停止该考生的服务。我方不对考生自行终止结束服务的选择所产生的后果承担任何责任。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3．对违反本协议以及本协议附属条款的考生，我方有权利终止对其服务。<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4．结束服务后，考生使用与网上报名相关的一切服务的权利即刻中止，考生没有权利要求，我方也没有义务对其网上查询、报考负任何责任。<br />
        八、关于信息发布<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我方将通过网上公告形式向考生发布提供权威资讯，先告知服务条款的修改、服务变更或其它重要事项。<br />
        九、法律<br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;网上报考及查询等服务条款均要遵守国家的法律、法规，考生和我方一致同意服从有管辖权法院管辖。若我方部分服务条款与法律、法规相抵触，并不影响其他条款的法律效力。
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agree">我已阅读</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getContentList } from "@/api/home";

export default {
  name: "XWLoginForm",
  data() {
    return {
      loginForm: {
        idCode: "",
        password: "",
        isAgree: true,
      },
      contentList: [],
      dialogVisible: false,
      rules: {
        idCode: [
          {
            required: true,
            message: "请输入您的身份证号码",
            trigger: "blur",
          },
          {
            pattern:
              /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入您的密码",
            trigger: "blur",
          } /*, {
          pattern: /^[0-9A-Za-z]{6,}$/,
          message: '密码长度不能小于六位',
          trigger: 'blur'
        }*/,
        ],
        isAgree: [
          {
            required: true,
            type: "boolean",
            message: "请先同意报名协议",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    // 点击登录
    handleClick() {
      this.$refs["编辑"].validate((valid) => {
        if (!valid) return;
        this.$emit("login", this.loginForm);
      });
    },
    //
    toRegister() {
      this.$emit("register");
    },
    // 忘记密码
    lossPassword() {
      this.$emit("missPwd");
    },
    agree() {
      this.dialogVisible = false;
      this.loginForm.isAgree = true;
    },
    getPageData() {
      let _that = this;
      getContentList(1).then((res) => {
        // console.log(res);
        if (res.data.success) {
          _that.contentList = res.data.obj;
        }
      });
    },
    // 查看公告
    checkContent(val) {
      window.open(
        "/apply/contentInfo/getContentInfoById?id=" + val.id,
        "_blank"
      );
    },
  },
  computed: {
    wanglaoban: function () {
      return this.contentList.filter((item, index) => {
        return index < 5;
      });
    },
  },
};
</script>

<style scoped>
.login_form_box {
  position: absolute;
  top: 50%;
  right: 20%;
  transform: translate(0, -50%);
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
  width: 25%;
}

.loginForm input {
  border: none;
  height: 100%;
  flex: 1;
  outline: none;
}

.login-item span {
  height: 100%;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-item img {
  height: 16px;
}

.login-register {
  font-size: 0.6rem;
  display: flex;
  margin-top: 40px;
}

.login-register .lossPwd {
  color: #f21313;
  flex: 1;
  cursor: pointer;
}

.goRegester {
  cursor: pointer;
}

.goRegester span {
  color: #f21313;
}

.login-flag {
  font-size: 0.6rem;
  color: #ccc;
  text-align: center;
  letter-spacing: 1px;
}

.content {
  font-size: 15px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  line-height: 2;
  margin-left: 10%;
  margin-right: 10%;
  color: #44566c;
}

.notice {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(0, -50%);
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
  width: 25%;
  height: 15%;
}

.contentBox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/XWLoginForm/XWLoginForm.vue